/**
 * @generated SignedSource<<1df4c38b77a8cc155860c4199dcae1b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductShipping_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPriceV2_item">;
  readonly " $fragmentType": "ProductShipping_item";
};
export type ProductShipping_item$key = {
  readonly " $data"?: ProductShipping_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductShipping_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductShipping_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShippingPriceV2_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "aecf6a85d83ba95d42d049c6c59dd3fa";

export default node;
